import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { StatusApproval } from '../../../shared/enums/StatusApproval';
import { Approval } from '../../../models/Approval.model';
import { ContractType } from '../../../shared/enums/ContractType';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { ApprovalService } from '../../../services/approval.service';
import * as _ from 'lodash';
import { AwsService } from '../../../services/aws.service';
import { ToastsManager } from "ng2-toastr";
import { Router } from '@angular/router';
import { LocalStorage } from "../../../shared/wrappers/LocalStorage";
import { GUARDS } from '../../../shared/auth/Roles';

@Component({
  selector: 'app-consultant-listing',
  templateUrl: './consultant-listing.component.html',
  styleUrls: ['./consultant-listing.component.scss']
})
export class ConsultantListingComponent implements OnInit {

    @Input() approvals;
    @Input() approvalsSearch;
    @Input() currentPage;
    @Input() totalItems;
    @Output() downloadApprovalInvoice: EventEmitter<any> = new EventEmitter();
    customerExpand:boolean = false;
    hashCustomerExpand:boolean =false;
    currentUser;
    showValue: boolean = true;

    constructor(private approvalService:ApprovalService,
                public toastr:ToastsManager,
                public router: Router,
                private localStorage: LocalStorage,
                public commonHelper:CommonHelper ) { }

    async ngOnInit() {
        this.currentUser = this.localStorage.retrieve('user')
        if (this.currentUser.permission === GUARDS.BUSINESSPARTNER) {
            this.showValue = false;
        }
    }


    verifyColorColumn(status: number) {
        let cssClass = "";
        if (status == StatusApproval.Pago)
            cssClass = "pago";

        if (status == StatusApproval.AprovacaoPendente)
            cssClass = "aprovacao-pendente";

        if (status == StatusApproval.PagamentoPendente)
            cssClass = "pagamento-pendente";

        if (status == StatusApproval.AguardandoRacional)
            cssClass = "aguardando-racional";

        return cssClass;

    }

    buldContractType(approval: Approval) {
        let type = approval.consultant.contract.kind;
        let honor = approval.consultant.contract.honorarium;

        let transcriptType = this.commonHelper.transcriptContractType(type);
        let transcriptHonor = this.commonHelper.transcriptHonorariumType(honor);

        if (type === ContractType.PJ)
            return `${transcriptType} (${transcriptHonor})`;

        return `${transcriptType}`;
    }

    buildCutomersForGrid(approval: Approval, hashtrack) {
        let response = [];
        for (var i = 0; i < approval.projects.length; i++) {

            if(hashtrack){
                if (approval.projects[i].customer !== undefined && approval.projects[i].customer.name !== undefined) {
                    if (approval.projects[i].customer.name.length > 0)
                        response.push(approval.projects[i].customer.name);
                }
            }else{
                if (approval.projects[i].customer !== undefined && approval.projects[i].customer.financialName !== undefined) {
                    if (approval.projects[i].customer.financialName.length > 0)
                        response.push(approval.projects[i].customer.financialName);
                }
            }
        }
        if (response.length == 0)
            response.push('-')
        return response.join(',');
    }

    updateCheckList(value: any){
        let isChecked = value.target.checked;
        if(isChecked && !_.includes(this.approvalService.multiApprovals,value.target.id) ){
            this.approvalService.multiApprovals.push(value.target.id);
        }
        else{
            this.approvalService.multiApprovals = _.remove(this.approvalService.multiApprovals, function(n){
                return !(n == value.target.id);
            });
        }
    }


    checkAll(value:any) {
        let checksItems = document.querySelectorAll('[name="selectbox"]'),
        checkBoxes = Array.prototype.slice.call(checksItems),
        isChecked = value.target.checked,
        multiCheck = this.approvalService.multiApprovals = [];

        if(isChecked){
            for(let check of checkBoxes){
                check.checked = true;
                multiCheck.push(check.getAttribute('id'));
            }
        }else{
            for(let check of checkBoxes){
                check.checked = false;
            }
        }
      }

    toggleCustomerExpand(approval){
        approval.customerExpand = !approval.customerExpand;
    }

    toggleHashCustomerExpand(approval){
        approval.hashCustomerExpand = !approval.hashCustomerExpand;
    }

    checkForNames(approval, property){
        let response:boolean = false;
        if(approval.projects && approval.projects.length > 1){
            approval.projects.forEach(project =>{
                if(project.customer[property] && project.customer[property].length > 0){
                    response = true;
                }
            });
        }
        return response;
    }

    downloadInvoice(approval){
        this.downloadApprovalInvoice.emit(approval);
    }

    hasPermission(approval: Approval): void {
        const permissionRoles = [GUARDS.MANAGER, GUARDS.FINANCES, GUARDS.GOVERNANCE, GUARDS.CONTROLLERSHIP, GUARDS.ACCOUNTING]
        if(!permissionRoles.includes(this.currentUser.permission)) {
            this.toastr.warning('Você não possui permissão para acessar esta aprovação', 'Operação bloqueada')
            return;
        }

        const approvalExcellenceCenterId = approval.consultant.excellenceCenter ? approval.consultant.excellenceCenter._id : ''

        if (!approvalExcellenceCenterId) {
            this.router.navigate([`/approvals/approvals-edit/${approval._id}`])
            return;
        }

        if(this.currentUser.permission !== GUARDS.FINANCES && (!this.currentUser.excellenceCenters || !this.currentUser.excellenceCenters.find(({ _id }) => _id === approvalExcellenceCenterId))) {
            this.toastr.warning('Você não possui permissão para acessar esta aprovação', 'Operação bloqueada')
            return
        }
        this.router.navigate([`/approvals/approvals-edit/${approval._id}`])
    }
}



// WEBPACK FOOTER //
// ./src/app/views/approvals/consultant-listing/consultant-listing.component.ts